module.exports = "\r\nth {\r\n    font-weight: normal;\r\n    font-size: 8pt;\r\n}"